import { els, breakpoints } from './variables';

const stickyCta = {
	init() {
		this.el = document.querySelector('.js-sticky-cta');
		if (this.el) {
			this.updateFooterPadding = this.updateFooterPadding.bind(this);
			window.addEventListener('load', this.updateFooterPadding);
			window.addEventListener('resize', this.updateFooterPadding);
			window.addEventListener('orientationchange', this.updateFooterPadding);
		}
	},

	updateFooterPadding() {
		window.requestAnimationFrame(() => {
			if (els.footer && breakpoints.sm.belowMin()) {
				els.footer.style.paddingBottom = `${this.el.offsetHeight + 20}px`;
			} else {
				els.footer.style.paddingBottom = '';
			}
		});
	},
};

stickyCta.init();
